//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'BlogSearch',
  props: {
    lang: {
      type: String,
      default: 'en'
    }
  },
  data () {
    return {
      searchValue: '',
      autocomplete: [],
      latest: []
    }
  },
  filters: {
    mark (val, rep) {
      function capitalizeFirstLetter (val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1)
      }
      const res = val.replace(capitalizeFirstLetter(rep), '<b>' + capitalizeFirstLetter(rep) + '</b>')
      return res.replace(rep, '<b>' + rep + '</b>')
    }
  },
  watch: {
    async searchValue (value) {
      if (value.length > 2) {
        try {
          const { data } = await this.$axios.get('/api/blogs/autocomplete?lang=' + this.lang + '&q=' + value)
          this.latest = data.latest
          this.autocomplete = data.results
        } catch (e) {
          this.latest = []
          this.autocomplete = []
        }
      } else {
        this.latest = []
        this.autocomplete = []
      }
    }
  },
  methods: {
    close () {
      this.latest = []
      this.autocomplete = []
    },
    startSearch () {
      window.location.href = '/' + this.lang + '/blog-search/?q=' + this.searchValue
    }
  }
}
